export default __webpack_public_path__ + "static/media/245.f6f992a4.png";